import store from "../App/store";

/**
 * Authorization header for the External AI axios calls (upload + status).
 * Reads the same token source as RTK Query (roomNateApis prepareHeaders) so
 * signed-in uploads carry the user identity the rest of the app uses.
 *
 * Returns {} when unauthenticated — callers must spread the result into the
 * axios `headers` object so anonymous requests remain byte-identical to
 * today's behavior (no empty "Authorization" header, no "Bearer " prefix
 * with an empty value).
 *
 * @returns {{ Authorization?: string }}
 */
export function getExternalAiAuthorizationHeaders() {
  try {
    const currentToken = store.getState()?.roomNateSlice?.currentToken;
    if (!currentToken) return {};
    const stripped = String(currentToken).replace(/["]/g, "");
    if (!stripped) return {};
    return { Authorization: `Bearer ${stripped}` };
  } catch (err) {
    // Never block an upload because of a header helper failure.
    console.warn("[externalAiAuthHeaders] Failed to resolve token:", err);
    return {};
  }
}
